import { GeneralService } from 'src/app/services/general.service';
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormularioService } from './services/formulario.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  public title: string;

  constructor(protected generalService: GeneralService, protected http: HttpClient, protected formularioService: FormularioService) {

  }

  async ngOnInit(): Promise<void> {
    this.parseJwt();
    await this.formularioService.getUser().pipe(take(1)).toPromise().then(response => {

      this.generalService.setUserNameValue(response['user-profile']?.displayName);
    }).catch(error => {
    });
    this.title = 'product-supply-data-pipeline-form';
    setInterval(async () => await this.checkConnection(), 5000);
  }

  async checkConnection(): Promise<void> {
    fetch('/').then(response => {
      this.generalService.setConnectionStatusNetwork(true);
    }).catch(error => {
      this.generalService.setConnectionStatusNetwork(false);
    });
  }

  redirect() {
    window.open("https://teams.microsoft.com/l/team/19%3aDNEwp3x8aDCB5rNE8SFwmazpKC9PyCaruFtFc1YEOCQ1%40thread.tacv2/conversations?groupId=59741644-5964-488a-bffb-68b7d6947b55&amp;tenantId=fcb2b37b-5da0-466b-9b83-0014b67a7c78", "_blank");
  }

  parseJwt() {
    var base64Url = this.getCookie('frontend-app')?.split('.')[1];
    var base64 = base64Url?.replace(/-/g, '+')?.replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64)?.split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    let json = JSON.parse(jsonPayload);
    localStorage.setItem('cwid-user', json['https://bayer.com/cwid']);

  };

  getCookie(name): string {
    let cookie = {};
    document.cookie.split(';').forEach(function (el) {
      let [k, v] = el.split('=');
      cookie[k.trim()] = v;
    })

    return cookie[name];
  }

}
